<template>
	<div id="app">
		<a-layout style="height: 100vh;">
			<a-layout-header style="color: #fff;">简单通讯录</a-layout-header>
			<a-layout-content style="background-color: #fff;">
				<a-row style="margin-top: 3.75rem;">
					<a-col :span="8" :offset="8">
						<a-page-header style="border: 0px solid rgb(235, 237, 240);" title="登录" sub-title="记得多加维护" />
						<a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
							<a-form-item label="访问密码:">
								<a-input v-decorator="['xpwd', { rules: [{ required: true, message: '请输入密码!' }] }]" />
							</a-form-item>
							<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
								<a-button type="primary" html-type="submit">登录</a-button>
							</a-form-item>
						</a-form>
					</a-col>
				</a-row>
			</a-layout-content>
			<a-layout-footer style="text-align: center">
				<p>本平台用于管理日常简单通讯录，方便查找</p>
				<p>版权所有，翻版必究</p>
				<p>网站备案号：<a href="https://beian.miit.gov.cn">浙ICP备14001541号-3</a></p>
			</a-layout-footer>
		</a-layout>
	</div>
</template>

<script>
	// import HelloWorld from './components/HelloWorld.vue'

	export default {
		name: 'App',
		components: {
			// HelloWorld
		},
		data() {
			return {
				formLayout: 'horizontal',
				form: this.$form.createForm(this, {
					name: 'coordinated'
				}),
			};
		},
		methods: {
			handleSubmit(e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						console.log('Received values of form: ', values);
					}
				});
			},
		},
	}
</script>

<style>

</style>
